<template>
    <div :class="[!isPrintMode && 'px-[20px] lg:px-[40px]']">
        <div class="flex flex-col w-full flex-1" v-if="!isPrintMode">
            <div class="mt-[29.73px]"></div>
            <p class="text-base font-semibold border-b border-gray-light mb-2">
                <template v-if="hideTotalPricing">
                    {{ $t('FINAL_PRICE_WILL_BE_CALCULATED_IN_CART') }}
                </template>
                <template v-else>
                    {{ $t('YOUR_PUTTERS') }}
                </template>
            </p>
            <div
                v-if="!hideTotalPricing"
                class="px-3 py-3 flex justify-between bg-gray-FAFAFA font-semibold text-[14px]"
            >
                <div>
                    {{ $t('PRICE') }}
                </div>
                <div>
                    <template v-if="productPriceCurrent != null">
                        {{ productPriceCurrent }}/{{ $t('CLUB') }}
                    </template>
                    <span v-else>
                        &nbsp;
                    </span>
                </div>
            </div>
        </div>

        <summary-details />

        <div class="flex flex-col flex-1 h-full" />
    </div>
</template>

<script>
    import allStores from '../stores/all';

    import SummaryDetails from './SummaryDetails.vue';

    export default {
        mixins: [allStores],

        components: {
            SummaryDetails,
        },

        computed: {
            productPriceCurrent() {
                return this.customizerStore.currentPriceFormatted?.current;
            },

            hideTotalPricing() {
                return this.customizerStore.options.pricingOverride?.hideTotalPricing;
            },

            isPrintMode() {
                return this.appStore.isPrintMode;
            },
        },
    };
</script>
